var $0d4d5529b4c88529$exports = {};
$0d4d5529b4c88529$exports = {
    "replaceMessage": `Pa\u{161}alinkite fail\u{105}, kad pakeistum\u{117}te`
};


export {$0d4d5529b4c88529$exports as default};
//# sourceMappingURL=lt-LT.mjs.map
